import type { L } from '../types/i18n'

export interface GalleryItem {
  src: string
  label: L
  caption: L
  span?: boolean
}

export const galleryItems: GalleryItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/cqZyCPNeiuGEQ1K5TuT84o/Banner_AJ_Auto_repair.jpg',
    label: { en: 'Diagnostics', es: 'Diagnóstico' },
    caption: {
      en: 'Running a scan before a single part gets ordered',
      es: 'Escaneo antes de pedir una sola pieza',
    },
    span: true,
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/deb7d939-8889-447c-a17d-f7585bdb4bf9.jpg',
    label: { en: 'Our Shop', es: 'Nuestro Taller' },
    caption: {
      en: '910 Pulaski Hwy — easy in, easy out, plenty of parking',
      es: '910 Pulaski Hwy — fácil entrada y salida, con estacionamiento',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/5dcc1146-3f52-4c0e-b554-883203821ec3.jpg',
    label: { en: 'Service Bays', es: 'Bahías de Servicio' },
    caption: {
      en: 'Clean, organized bays with full lift access',
      es: 'Bahías limpias y ordenadas con acceso a elevadores',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/05460e85-5096-45a8-83e8-64eb38a8b3ec.jpg',
    label: { en: 'Brake Service', es: 'Servicio de Frenos' },
    caption: {
      en: 'New rotors and pads going on a daily driver',
      es: 'Discos y pastillas nuevas en un auto de uso diario',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/bc07183d-a2d8-4a27-a45c-85a8576030e2.jpg',
    label: { en: 'Our Team', es: 'Nuestro Equipo' },
    caption: {
      en: 'The crew that will be working on your vehicle',
      es: 'El equipo que trabajará en tu vehículo',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8c5f46e6-89f9-4bdf-a669-f7d04d940de2.jpg',
    label: { en: 'Suspension', es: 'Suspensión' },
    caption: {
      en: 'Strut assembly replacement, front left',
      es: 'Cambio de amortiguador delantero izquierdo',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/37271986-eef5-4029-aa55-ae05eaf6f722.jpg',
    label: { en: 'Oil Change', es: 'Cambio de Aceite' },
    caption: {
      en: 'Correct oil weight, quality filter, every time',
      es: 'Aceite correcto y filtro de calidad, siempre',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ecf5899a-f6fb-4e91-8f0f-fcdef694f3be.jpg',
    label: { en: 'A/C Service', es: 'Servicio de A/C' },
    caption: {
      en: 'Pressure testing a system before recharging it',
      es: 'Prueba de presión antes de recargar el sistema',
    },
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/3c1ef5bd-9641-423c-8b9b-7aa486aff19c.jpg',
    label: { en: 'Diagnostics', es: 'Diagnóstico' },
    caption: {
      en: 'Verifying codes against live data',
      es: 'Verificación de códigos con datos en vivo',
    },
  },
]
